import React from "react";
import "./newhome.css";
import Marquee from "react-fast-marquee";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/swiper-bundle.css";
import "swiper/css/navigation";
import { Pagination, EffectFade, Autoplay, Navigation } from "swiper/modules";
import services from "../../Static";
import GetInTouch from "../../ContactUs/GetInTouch";
import Testimonies from "../../Testimonies";
import { useNavigate } from "react-router-dom";
import SpliderHero from "../../Hero/SpliderHero";

const NewHome = () => {
  const navigate = useNavigate();

  return (
    <div className="NewHome_div">
      <SpliderHero />

      {/* ==================== WELCOME ==================== */}
      <section className="relative bg-[#ffffff] py-16">
        {/* subtle background accent */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -left-24 top-10 h-48 w-48 rounded-full bg-[#00ad0f]/5 blur-3xl" />
          <div className="absolute right-0 bottom-0 h-56 w-56 rounded-full bg-[#062b6c]/5 blur-3xl" />
        </div>

        <div className="relative mx-auto max-w-6xl px-6">
          {/* main card */}
          <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-white/95 shadow-[0_25px_80px_rgba(15,23,42,0.15)]">
            {/* top accent */}
            <div className="absolute inset-x-10 top-0 h-[4px] rounded-b-full bg-gradient-to-r from-[#00ad0f] via-[#7fffb0] to-[#062b6c]" />

            <div className="flex flex-col gap-8 px-8 py-12 text-center md:px-14">
              {/* Heading */}
              <div className="flex flex-col items-center gap-4">
                <span className="inline-flex items-center gap-2 rounded-full bg-[#062b6c]/5 px-5 py-1.5 text-[12px] uppercase tracking-[0.26em] text-[#062b6c]">
                  <span className="h-2.5 w-2.5 rounded-full bg-[#00ad0f]" />
                  Welcome
                </span>

                <h2 className="text-4xl font-extrabold text-[#062b6c] md:text-5xl lg:text-[3.5rem]">
                  <span className="block text-sm font-semibold uppercase tracking-[0.32em] text-slate-500 mb-1">
                    to
                  </span>
                  <span className="bg-gradient-to-r from-[#062b6c] to-[#00ad0f] bg-clip-text text-transparent leading-tight">
                    Scaftech
                  </span>
                </h2>
              </div>

              {/* Description */}
              <p className="mx-auto w-full max-w-3xl text-base leading-relaxed text-slate-700 md:text-xl">
                We serve a diverse range of industries, including Oil &amp; Gas,
                Marine, and Construction. Leveraging the expertise of our
                multi-skilled workforce, we deliver comprehensive, integrated
                solutions designed to address complex asset integrity
                challenges. Our tailored services ensure the most effective and
                efficient outcomes for our clients.
              </p>

              {/* Chips */}
              <div className="mt-3 flex flex-wrap items-center justify-center gap-4 text-[12px] font-semibold uppercase tracking-[0.22em] text-slate-700">
                <span className="rounded-full border border-slate-300 bg-slate-50 px-4 py-1.5">
                  Oil &amp; Gas
                </span>
                <span className="rounded-full border border-slate-300 bg-slate-50 px-4 py-1.5">
                  Marine
                </span>
                <span className="rounded-full border border-slate-300 bg-slate-50 px-4 py-1.5">
                  Construction
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== CLIENTS MARQUEE ==================== */}
      <section
        id="clients"
        className="relative border-y border-[#062b6c]/10 bg-[#020819] py-10"
      >
        {/* subtle top accent line */}
        <div className="pointer-events-none absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-[#00ad0f] via-white/40 to-[#062b6c]" />

        <div className="container2 relative px-6">
          {/* Header row */}
          <div className="mb-6 flex flex-col items-center justify-between gap-3 text-center md:flex-row md:text-left">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.26em] text-[#7fb2ff]">
                Trusted by industry leaders
              </p>
              <h3 className="mt-1 text-xl font-semibold text-white md:text-2xl">
                Partners and Clients We’ve Worked With
              </h3>
            </div>

            <div className="inline-flex items-center gap-2 rounded-full border border-[#00ad0f]/40 bg-[#062b6c]/40 px-4 py-1 text-[11px] font-medium uppercase tracking-[0.18em] text-[#e3ffe9]">
              <span className="h-2 w-2 rounded-full bg-[#00ad0f] shadow-[0_0_8px_rgba(0,173,15,0.9)]" />
              <span>Oil &amp; Gas • Marine • Construction</span>
            </div>
          </div>

          {/* Logos rail */}
          <div className="overflow-hidden rounded-2xl border border-[#062b6c]/50 bg-[radial-gradient(circle_at_0%_0%,rgba(0,173,15,0.22),transparent_60%),linear-gradient(to_right,rgba(6,43,108,0.96),rgba(6,43,108,0.92))] px-4 py-4">
            <Marquee
              speed={70}
              gradient={true}
              gradientWidth={80}
              gradientColor={[2, 8, 23]}
              autoFill
              direction="left"
            >
              {[
                "/sponsors/sponsor-2.webp",
                "/sponsors/sponsor-3.webp",
                "/sponsors/sponsor-4.webp",
                "/sponsors/sponsor-6.webp",
                "/sponsors/sponsor-8.webp",
              ].map((src, idx) => (
                <div
                  key={idx}
                  className="mx-8 flex items-center justify-center opacity-80 transition-transform duration-200 hover:scale-105 hover:opacity-100"
                >
                  <img
                    src={src}
                    alt="Client logo"
                    className="max-h-12 w-auto object-contain invert-0 md:max-h-14"
                  />
                </div>
              ))}
            </Marquee>
          </div>
        </div>
      </section>

      {/* ==================== WHO WE ARE ==================== */}
      <section className="about_new_section relative overflow-hidden py-14 lg:py-24">
        {/* subtle brand accents */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -left-10 top-10 h-40 w-40 rounded-full bg-[#fff] blur-3xl" />
          <div className="absolute right-[-60px] bottom-0 h-56 w-56 rounded-full bg-[#062b6c]/30 blur-3xl" />
        </div>

        <div className="container2 relative">
          <div className="about_new_section_area">
            {/* heading row */}
            <div className="mb-8 flex flex-col items-center gap-3 text-center lg:items-start lg:text-left">
              <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1 text-[11px] font-semibold uppercase tracking-[0.26em] text-[#d0e6ff]">
                <span className="h-2 w-2 rounded-full bg-[#00ad0f] shadow-[0_0_10px_rgba(0,173,15,0.9)]" />
                Who We Are
              </span>
              <div className="text-clamp font-semibold text-white">
                About{" "}
                <span className="about_new_section_area_head_span">
                  &nbsp;Scaftech
                </span>
              </div>
            </div>

            {/* content grid */}
            <div className="grid place-items-center gap-10 lg:place-items-stretch lg:items-center lg:justify-normal lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1.3fr)]">
              {/* Map / visual side */}
              <div className="about_new_section_area_body_1 flex justify-center lg:block">
                <div className="relative mx-auto overflow-hidden rounded-3xl border border-white/10 bg-[#020923]/70 p-6 backdrop-blur-xl lg:mx-0">
                  <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_0%_0%,rgba(0,173,15,0.22),transparent_55%),radial-gradient(circle_at_100%_100%,rgba(6,43,108,0.8),transparent_55%)]" />
                  <div className="relative flex flex-col items-center gap-4">
                    <img
                      src="/new_img/nigeria_dotted_map.svg"
                      alt="Nigeria map"
                      className="about_new_section_area_body_1_img max-h-72 w-auto object-contain"
                    />
                    <p className="text-[11px] uppercase tracking-[0.22em] text-[#b7d3ff] text-center">
                      Operational footprint across Nigeria and key regional hubs
                    </p>
                  </div>
                </div>
              </div>

              {/* Text / copy side */}
              <div className="flex w-full flex-col items-center text-center lg:items-start lg:text-left lg:ml-4">
                <div className="px-2 pb-3 text-3xl font-bold text-white md:text-4xl">
                  Company Overview
                </div>
                <div className="mb-8 max-w-xl text-justify text-clamp2 leading-[1.8] text-slate-100">
                  SCAFTECH Engineering Services is a pioneering engineering firm
                  co-founded by industry veterans with a vision to redefine
                  engineering standards. Our mission is to deliver innovative,
                  efficient, and cost-effective engineering solutions that
                  adhere to the highest safety and quality benchmarks.
                </div>

                {/* small info chips */}
                <div className="mb-6 flex flex-wrap items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#d0e6ff]">
                  <span className="rounded-full border border-white/20 bg-white/5 px-3 py-1">
                    Asset Integrity
                  </span>
                  <span className="rounded-full border border-white/20 bg-white/5 px-3 py-1">
                    Engineering Solutions
                  </span>
                  <span className="rounded-full border border-white/20 bg-white/5 px-3 py-1">
                    Training &amp; Competence
                  </span>
                </div>

                <button
                  onClick={() => {
                    navigate("/about");
                  }}
                  className="getstarted_button"
                >
                  Read More
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== WHY CHOOSE ==================== */}
      <section className="why_choose_new_section relative overflow-hidden bg-white py-14 lg:py-20">
        <div className="container2">
          <div className="why_choose_new_section_area">
            {/* Heading */}
            <div className="flex flex-col gap-4 px-6 text-center md:px-10">
              <span className="mx-auto inline-flex items-center gap-2 rounded-full border border-[#062b6c]/15 bg-[#062b6c]/5 px-5 py-1.5 text-[12px] font-semibold uppercase tracking-[0.22em] text-[#062b6c]">
                <span className="h-2 w-2 rounded-full bg-[#00ad0f] shadow-[0_0_6px_rgba(0,173,15,0.6)]" />
                Why Choose Us
              </span>

              <h2 className="text-clamp font-bold text-[#062b6c] leading-tight">
                Why Choose
                <span className="why_choose_new_section_area_1_title_span">
                  &nbsp;Scaftech
                </span>
              </h2>

              <p className="why_choose_new_section_area_1_para mx-auto max-w-3xl text-justify text-base md:text-lg text-slate-700">
                With over 2 decade of industry experience, we have earned a
                reputation for excellence, supported by a wide range of
                professional qualifications and accreditations. Our team
                comprises highly skilled technical experts and instructional
                professionals, ensuring the delivery of superior quality
                services and training solutions.
              </p>
            </div>

            {/* Cards */}
            <div className="mt-10 flex flex-col px-6 lg:flex-row lg:px-10">
              <div className="grid grid-cols-1 gap-8 xl:grid-cols-3">
                {/* Card 1 */}
                <div className="why_choose_new_section_area_2_cont1_div1 group relative flex flex-col overflow-hidden rounded-2xl border border-[#062b6c]/10 bg-[#f5f9ff] p-6 shadow-[0_12px_40px_rgba(15,23,42,0.06)] transition-transform hover:-translate-y-1 hover:shadow-[0_18px_50px_rgba(15,23,42,0.12)]">
                  <div className="absolute inset-x-6 top-0 h-[3px] bg-gradient-to-r from-[#00ad0f] to-[#062b6c]/80" />

                  <div className="mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#062b6c] text-white">
                        <MiscellaneousServicesIcon className="h-5 w-5" />
                      </div>
                      <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#062b6c]/70">
                        01 • Approach
                      </span>
                    </div>
                  </div>

                  <div className="space-y-3">
                    <div className="why_choose_new_section_area_2_cont1_div1_body_title text-[1.05rem] font-semibold text-[#062b6c]">
                      Our Job Handling Approach
                    </div>
                    <div className="why_choose_new_section_area_2_cont1_div1_body_para text-sm leading-relaxed text-slate-700">
                      A comprehensive understanding of the service work scope is
                      essential to achieving our core objectives of safety,
                      quality, and exceptional service delivery. This
                      foundational approach ensures precision, reliability, and
                      adherence to the highest industry standards.
                    </div>
                  </div>
                </div>

                {/* Card 2 */}
                <div className="why_choose_new_section_area_2_cont1_div1 group relative flex flex-col overflow-hidden rounded-2xl border border-[#062b6c]/10 bg-[#f5f9ff] p-6 shadow-[0_12px_40px_rgba(15,23,42,0.06)] transition-transform hover:-translate-y-1 hover:shadow-[0_18px_50px_rgba(15,23,42,0.12)]">
                  <div className="absolute inset-x-6 top-0 h-[3px] bg-gradient-to-r from-[#00ad0f] to-[#062b6c]/80" />

                  <div className="mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#062b6c] text-white">
                        <MiscellaneousServicesIcon className="h-5 w-5" />
                      </div>
                      <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#062b6c]/70">
                        02 • Expertise
                      </span>
                    </div>
                  </div>

                  <div className="space-y-3">
                    <div className="why_choose_new_section_area_2_cont1_div1_body_title text-[1.05rem] font-semibold text-[#062b6c]">
                      Certified &amp; Experienced Instructors
                    </div>
                    <div className="why_choose_new_section_area_2_cont1_div1_body_para text-sm leading-relaxed text-slate-700">
                      For many years, ScafTech has been a trusted provider of
                      specialized training services to the Oil &amp; Gas,
                      Marine, and Construction industries. Our expertise and
                      commitment to excellence have positioned us as a leader in
                      delivering tailored training solutions that meet the
                      unique demands of these sectors.
                    </div>
                  </div>
                </div>

                {/* Card 3 */}
                <div className="why_choose_new_section_area_2_cont1_div1 group relative flex flex-col overflow-hidden rounded-2xl border border-[#062b6c]/10 bg-[#f5f9ff] p-6 shadow-[0_12px_40px_rgba(15,23,42,0.06)] transition-transform hover:-translate-y-1 hover:shadow-[0_18px_50px_rgba(15,23,42,0.12)]">
                  <div className="absolute inset-x-6 top-0 h-[3px] bg-gradient-to-r from-[#00ad0f] to-[#062b6c]/80" />

                  <div className="mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#062b6c] text-white">
                        <MiscellaneousServicesIcon className="h-5 w-5" />
                      </div>
                      <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#062b6c]/70">
                        03 • Team
                      </span>
                    </div>
                  </div>

                  <div className="space-y-3">
                    <div className="why_choose_new_section_area_2_cont1_div1_body_title text-[1.05rem] font-semibold text-[#062b6c]">
                      Highly Trained Personnel
                    </div>
                    <div className="why_choose_new_section_area_2_cont1_div1_body_para text-sm leading-relaxed text-slate-700">
                      The personnel at ScafTech are highly experienced and
                      proficient in working at height. Our team specializes in a
                      range of critical services, including blasting,
                      inspection, installation, and repair, all conducted safely
                      and efficiently in elevated environments.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== SERVICES ==================== */}
      <section
        className="clients_new_section relative overflow-hidden bg-[#020819] py-16"
        id="services"
      >
        {/* background accents */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -left-24 top-0 h-64 w-64 rounded-full bg-[#00ad0f]/15 blur-3xl" />
          <div className="absolute right-[-40px] bottom-[-40px] h-72 w-72 rounded-full bg-[#062b6c]/35 blur-3xl" />
          <div className="absolute inset-0 opacity-[0.08] [background-image:linear-gradient(to_right,#101827_1px,transparent_1px),linear-gradient(to_bottom,#101827_1px,transparent_1px)] [background-size:48px_48px]" />
        </div>

        <div className="relative px-4 lg:px-16">
          <div className="mx-auto max-w-6xl">
            {/* Header block */}
            <div className="mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
              <div className="space-y-3">
                <span className="inline-flex items-center gap-2 rounded-full border border-[#00ad0f]/40 bg-[#062b6c]/30 px-4 py-1 text-[11px] font-semibold uppercase tracking-[0.26em] text-[#e4ffe9]">
                  <span className="h-2 w-2 rounded-full bg-[#00ad0f] shadow-[0_0_10px_rgba(0,173,15,0.9)]" />
                  Our Service Matrix
                </span>
                <h2 className="text-clamp font-semibold text-white">
                  Services We{" "}
                  <span className="clients_new_section_area_heading_span">
                    Offer.
                  </span>
                </h2>
                <p className="max-w-xl text-sm leading-relaxed text-slate-300 md:text-base">
                  From lifting operations to asset integrity and technical
                  training, Scaftech delivers integrated solutions engineered
                  for safety, reliability, and performance across critical
                  industries.
                </p>
              </div>

              <div className="flex flex-col items-start gap-2 text-[11px] uppercase tracking-[0.18em] text-slate-300 md:items-end">
                <span className="inline-flex items-center gap-2">
                  <span className="h-[1px] w-8 bg-slate-500" />
                  Oil &amp; Gas • Marine • Construction
                </span>
                <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[10px] text-slate-200">
                  Scroll to explore services
                </span>
              </div>
            </div>

            {/* Slider container card */}
            <div className="relative overflow-hidden rounded-3xl border border-white/8 bg-[#020819]/95 p-5 shadow-[0_24px_80px_rgba(0,0,0,0.7)] backdrop-blur-xl">
              {/* top accent line */}
              <div className="pointer-events-none absolute inset-x-10 top-0 h-[3px] rounded-b-full bg-gradient-to-r from-[#00ad0f] via-[#7fffb0] to-[#062b6c]" />

              <Swiper
                slidesPerView={3}
                spaceBetween={24}
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                }}
                breakpoints={{
                  50: { slidesPerView: 1, spaceBetween: 12 },
                  640: { slidesPerView: 1, spaceBetween: 16 },
                  768: { slidesPerView: 2, spaceBetween: 18 },
                  1024: { slidesPerView: 3, spaceBetween: 20 },
                  1400: { slidesPerView: 3, spaceBetween: 24 },
                }}
                loop
                autoplay={{
                  delay: 2600,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay, Pagination, Navigation, EffectFade]}
                navigation
                className="home_div_section1_swiper"
              >
                {services.map((data, index) => (
                  <SwiperSlide
                    key={data.id}
                    className="dash_home_products_swiper_slide"
                  >
                    <button
                      type="button"
                      id={data.id}
                      className="group relative flex h-full w-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-b from-[#050b18] to-[#020713] text-left transition-transform duration-300 hover:-translate-y-1 hover:border-[#00ad0f]/60"
                    >
                      {/* index + category strip */}
                      <div className="flex items-center justify-between px-4 pt-3 text-[10px] font-mono uppercase tracking-[0.2em] text-slate-400">
                        <span className="flex items-center gap-2">
                          <span className="h-1.5 w-1.5 rounded-full bg-[#00ad0f]" />
                          <span>0{index + 1}</span>
                        </span>
                        <span className="rounded-full bg-[#062b6c]/60 px-2 py-0.5 text-[9px] text-slate-100">
                          Scaftech Service
                        </span>
                      </div>

                      {/* image */}
                      <div className="relative mt-3 overflow-hidden px-4">
                        <div className="overflow-hidden rounded-2xl">
                          <img
                            src={data.img}
                            alt={data.title2}
                            className="home_div_section3_area_2_cont1_img h-40 w-full object-cover transition-transform duration-300 group-hover:scale-110"
                          />
                        </div>
                        <div className="pointer-events-none absolute inset-x-4 bottom-0 h-16 rounded-b-2xl bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                      </div>

                      {/* body */}
                      <div className="flex flex-1 flex-col gap-3 px-4 pb-4 pt-4">
                        <h3 className="text-base font-semibold text-white md:text-lg">
                          {data.title2}
                        </h3>

                        <p className="home_div_section3_area_2_cont1_para text-sm leading-relaxed text-slate-200/90">
                          {data.paragraph}
                        </p>

                        {/* chips */}
                        <div className="mt-1 flex flex-wrap gap-2 text-[10px] font-medium uppercase tracking-[0.2em] text-slate-300">
                          <span className="rounded-full border border-white/10 bg-white/5 px-2 py-0.5">
                            Certified
                          </span>
                          <span className="rounded-full border border-white/10 bg-white/5 px-2 py-0.5">
                            Field Tested
                          </span>
                        </div>

                        {/* footer call to action */}
                        <div className="mt-auto flex items-center justify-between pt-2 text-[11px] uppercase tracking-[0.18em]">
                          <span className="flex items-center gap-1 text-[#7fffb0]">
                            <span className="h-1.5 w-1.5 rounded-full bg-[#00ad0f]" />
                            Learn more
                          </span>
                          <span className="text-slate-400 group-hover:text-slate-100">
                            View details →
                          </span>
                        </div>
                      </div>
                    </button>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== AWARDS & CERTIFICATIONS ==================== */}
      <section className="relative min-h-[320px] px-5 py-20 overflow-hidden bg-[#f5f7fb]">
        {/* Soft brand accents */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -left-20 top-10 h-48 w-48 rounded-full bg-[#00ad0f]/12 blur-3xl" />
          <div className="absolute right-[-40px] bottom-[-40px] h-64 w-64 rounded-full bg-[#062b6c]/18 blur-3xl" />
        </div>

        <div className="relative mx-auto max-w-6xl flex flex-col lg:flex-row items-stretch gap-10">
          {/* LEFT SIDE */}
          <div className="w-full lg:w-[60%]">
            <div className="relative overflow-hidden rounded-3xl border border-[#062b6c]/10 bg-white/95 p-8 shadow-[0_20px_60px_rgba(15,23,42,0.12)]">
              {/* Accent Bar */}
              <div className="absolute inset-x-8 top-0 h-[3px] rounded-b-full bg-gradient-to-r from-[#00ad0f] via-[#7fffb0] to-[#062b6c]" />

              <div className="flex flex-col gap-6">
                {/* Mini badge */}
                <span className="inline-flex items-center gap-2 self-start rounded-full bg-[#062b6c]/5 px-4 py-1 text-[11px] font-semibold uppercase tracking-[0.26em] text-[#062b6c]">
                  <span className="h-2 w-2 rounded-full bg-[#00ad0f]" />
                  Recognition &amp; Compliance
                </span>

                {/* Heading */}
                <h2 className="text-clamp font-semibold leading-[1.1] text-[#062b6c] text-center lg:text-left">
                  Our Awards and
                  <span className="why_choose_new_section_area_1_title_span">
                    &nbsp; Certifications
                  </span>
                </h2>

                {/* Paragraph */}
                <p className="text-[0.98rem] leading-relaxed text-slate-700 md:text-lg text-justify">
                  ScafTech is a globally recognized leader in delivering
                  world-class Asset Integrity Assurance and Training services,
                  supporting clients throughout the entire asset life-cycle. We
                  serve a diverse range of industries, including Oil &amp; Gas,
                  Marine, and Construction. Leveraging the expertise of our
                  multi-skilled workforce, we provide comprehensive, integrated
                  solutions designed to address even the most complex asset
                  integrity challenges. Our tailored services ensure optimal
                  performance, safety, and reliability for our clients. With a
                  proven track record of excellence, ScafTech has established
                  itself as a premier oil servicing company and training center.
                  Discover why we are the trusted partner of choice for industry
                  leaders worldwide.
                </p>

                {/* CTA */}
                <a
                  href="/certification"
                  className="group relative inline-flex h-12 items-center justify-center overflow-hidden rounded-md bg-[#082b6c] px-6 font-medium text-neutral-200 duration-500 hover:bg-[#2b9768]"
                >
                  <span className="relative inline-flex items-center transition-all group-hover:-translate-x-6">
                    <span className="absolute -translate-y-0.5 translate-x-0 opacity-100 transition-all group-hover:-translate-x-6 group-hover:opacity-0">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                      >
                        <path
                          d="M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    <span className="pl-6">
                      View Accreditation &amp; Awards
                    </span>
                    <span className="absolute right-0 translate-x-12 opacity-0 transition-all group-hover:translate-x-6 group-hover:opacity-100">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                      >
                        <path
                          d="M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z"
                          fill="currentColor"
                          fillRule="evenodd"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </span>
                </a>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="w-full lg:w-[40%]">
            <div className="flex flex-col gap-4 rounded-3xl border border-[#062b6c]/10 bg-white/80 p-6 shadow-[0_16px_40px_rgba(15,23,42,0.12)]">
              <div className="flex items-center justify-between">
                <span className="text-xs font-semibold uppercase tracking-[0.24em] text-[#062b6c]">
                  At a Glance
                </span>
                <span className="px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#00ad0f] rounded-full bg-[#00ad0f]/10">
                  Verified
                </span>
              </div>

              <div className="grid gap-3 text-sm text-slate-800">
                {/* Badge 1 */}
                <div className="flex items-start gap-3 rounded-2xl bg-[#f0f6ff] px-4 py-3">
                  <span className="mt-1 h-2 w-2 rounded-full bg-[#00ad0f]" />
                  <div>
                    <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#062b6c]">
                      ISO Standards
                    </div>
                    <div className="text-[0.9rem]">
                      Compliant with global quality and safety frameworks.
                    </div>
                  </div>
                </div>

                {/* Badge 2 */}
                <div className="flex items-start gap-3 rounded-2xl bg-[#f3fff7] px-4 py-3">
                  <span className="mt-1 h-2 w-2 rounded-full bg-[#00ad0f]" />
                  <div>
                    <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#14532d]">
                      Industry Coverage
                    </div>
                    <div className="text-[0.9rem]">
                      Oil &amp; Gas, Marine &amp; Construction service
                      excellence.
                    </div>
                  </div>
                </div>

                {/* Badge 3 */}
                <div className="flex items-start gap-3 rounded-2xl bg-[#eef4ff] px-4 py-3">
                  <span className="mt-1 h-2 w-2 rounded-full bg-[#00ad0f]" />
                  <div>
                    <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#1e3a8a]">
                      Proven Track Record
                    </div>
                    <div className="text-[0.9rem]">
                      Recognized globally for operational impact &amp;
                      reliability.
                    </div>
                  </div>
                </div>
              </div>

              <span className="mt-1 text-[11px] uppercase tracking-[0.22em] text-slate-500">
                View full list on certification page.
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== GALLERY ==================== */}
      <section className="gallery_new_section relative overflow-hidden bg-[#020819] py-16">
        {/* soft brand accents */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -left-24 top-0 h-56 w-56 rounded-full bg-[#00ad0f]/18 blur-3xl" />
          <div className="absolute right-[-40px] bottom-[-40px] h-64 w-64 rounded-full bg-[#062b6c]/35 blur-3xl" />
        </div>

        <div className="container2 relative flex flex-col">
          {/* Heading */}
          <div className="mb-8 flex flex-col items-center gap-3 text-center lg:items-start lg:text-left">
            <span className="inline-flex items-center gap-2 rounded-full border border-[#00ad0f]/40 bg-[#062b6c]/40 px-4 py-1 text-[11px] font-semibold uppercase tracking-[0.26em] text-[#e4ffe9]">
              <span className="h-2 w-2 rounded-full bg-[#00ad0f] shadow-[0_0_10px_rgba(0,173,15,0.9)]" />
              Field Highlights
            </span>
            <div className="leading-[1] text-clamp font-semibold text-white">
              Amazing{" "}
              <span className="gallery_new_section_area_title_span">
                Gallery
              </span>
            </div>
            <p className="max-w-xl text-sm leading-relaxed text-slate-300">
              A snapshot of Scaftech in action across lifting operations, access
              solutions, maintenance, and high-risk environments.
            </p>
          </div>

          {/* Collage card */}
          <div className="gallery_new_section_area relative overflow-hidden rounded-3xl border border-white/10 bg-[#020819]/95 p-5 shadow-[0_24px_80px_rgba(0,0,0,0.7)] backdrop-blur-xl">
            {/* accent strip */}
            <div className="pointer-events-none absolute inset-x-10 top-0 h-[3px] rounded-b-full bg-gradient-to-r from-[#00ad0f] via-[#7fffb0] to-[#062b6c]" />

            <div className="flex flex-col items-center gap-4 lg:flex-row lg:items-stretch lg:gap-4">
              {/* Large primary image */}
              <div className="relative w-full lg:w-[40%]">
                <div className="overflow-hidden rounded-2xl border border-white/10">
                  <img
                    src="/new_img/heavy-lines.jpeg"
                    alt="Heavy lines operation"
                    className="gallery_new_section_area_body_cont1_img h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                </div>
                <div className="pointer-events-none absolute bottom-4 left-4 right-4 flex items-center justify-between text-[11px] uppercase tracking-[0.2em] text-slate-100">
                  <span>Heavy Lifting &amp; Rigging</span>
                  <span className="rounded-full bg-[#00ad0f]/25 px-3 py-0.5 text-[10px] text-[#e4ffe9]">
                    In Field
                  </span>
                </div>
              </div>

              {/* Right column – 4 tiles */}
              <div className="grid w-full gap-4 lg:w-[60%] lg:grid-cols-2">
                <div className="relative overflow-hidden rounded-2xl border border-white/10">
                  <img
                    src="/new_img/equipment-leasing.webp"
                    alt="Equipment leasing"
                    className="gallery_new_section_area_body_cont2_img1 h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  <div className="absolute bottom-3 left-3 text-[11px] uppercase tracking-[0.2em] text-slate-100">
                    Equipment Leasing
                  </div>
                </div>

                <div className="relative overflow-hidden rounded-2xl border border-white/10">
                  <img
                    src="/new_img/equipment-maintenance.webp"
                    alt="Equipment maintenance"
                    className="gallery_new_section_area_body_cont2_img2 h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  <div className="absolute bottom-3 left-3 text-[11px] uppercase tracking-[0.2em] text-slate-100">
                    Maintenance &amp; Support
                  </div>
                </div>

                <div className="relative overflow-hidden rounded-2xl border border-white/10">
                  <img
                    src="/new_img/highrise-cleaning.webp"
                    alt="Highrise cleaning"
                    className="gallery_new_section_area_body_cont3_img1 h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  <div className="absolute bottom-3 left-3 text-[11px] uppercase tracking-[0.2em] text-slate-100">
                    Work at Height
                  </div>
                </div>

                <div className="relative overflow-hidden rounded-2xl border border-white/10">
                  <img
                    src="/new_img/scaffolding.webp"
                    alt="Scaffolding"
                    className="gallery_new_section_area_body_cont3_img2 h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  <div className="absolute bottom-3 left-3 text-[11px] uppercase tracking-[0.2em] text-slate-100">
                    Access &amp; Scaffolding
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-8 self-center">
            <a
              href="/gallery"
              className="my-4 group relative inline-flex h-12 items-center justify-center overflow-hidden rounded-full bg-[#082b6c] px-8 text-sm font-semibold uppercase tracking-[0.2em] text-neutral-200 duration-500 hover:bg-[#2b9768]"
            >
              <div className="relative inline-flex items-center transition group-hover:-translate-x-6">
                <span className="pl-2">View Full Gallery</span>
                <div className="absolute right-0 translate-x-12 opacity-0 transition group-hover:translate-x-6 group-hover:opacity-100">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                  >
                    <path
                      d="M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* ==================== LAST CTA ==================== */}
      <section className="relative overflow-hidden bg-[#020819] py-20">
        {/* Accents */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -left-24 top-10 h-56 w-56 rounded-full bg-[#00ad0f]/20 blur-3xl" />
          <div className="absolute bottom-[-80px] right-[-40px] h-80 w-80 rounded-full bg-[#062b6c]/30 blur-[100px]" />
        </div>

        <div className="container relative z-10 px-6 text-center lg:px-10">
          <h2 className="text-clamp3 mb-6 font-extrabold leading-tight text-white lg:text-left">
            Looking for a <span className="text-[#00ad0f]">Leading</span> Oil
            &amp; Gas
            <br /> Service Provider?
          </h2>

          <p className="mx-auto mb-10 max-w-2xl text-sm leading-relaxed text-slate-300 lg:text-left">
            We deliver certified engineering solutions, lifting operations,
            inspection services and technical training to the world’s most
            demanding industries. Ready to transform your operations with
            reliability and safety at the core?
          </p>

          <div className="flex justify-center lg:justify-start">
            <a
              href="https://wa.me/2348161637797"
              target="_blank"
              rel="noreferrer"
              className="group relative inline-flex items-center gap-3 overflow-hidden rounded-full bg-[#00ad0f] px-8 py-3 font-semibold uppercase tracking-wider text-white transition-all hover:scale-[1.03] hover:bg-[#00970d]"
            >
              {/* shine effect */}
              <span className="absolute -right-6 top-0 h-full w-1 origin-left -rotate-45 bg-white opacity-20 transition-all group-hover:right-full group-hover:duration-700"></span>

              <span>Drop a Message</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 transition-transform group-hover:translate-x-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
            </a>
          </div>
        </div>

        {/* Background image — Blended elegantly */}
        <img
          src="/img/last_sec_img.jpeg"
          alt="Operational Excellence"
          className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-20 mix-blend-overlay"
        />
      </section>

      <Testimonies />
      <GetInTouch />
    </div>
  );
};

export default NewHome;
